import Decimal from 'decimal.js';
import { filterMoneyInput } from './digits.js';

Decimal.set({ precision: 28, rounding: Decimal.ROUND_HALF_UP });

export function toMoney(value: unknown): Decimal {
  if (value instanceof Decimal) return value;
  if (value === null || value === undefined || value === '') return new Decimal(0);
  const n = Number(value);
  if (!Number.isFinite(n)) throw new Error('Invalid money value');
  return new Decimal(n);
}

export function roundMoney(value: unknown): string {
  return toMoney(value).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toFixed(2);
}

export function sumMoney(values: unknown[]): string {
  return values.reduce((acc: Decimal, v) => acc.plus(toMoney(v)), new Decimal(0)).toFixed(2);
}

export function parseMoneyInput(raw: string): string {
  const cleaned = filterMoneyInput(raw.replace(/,/g, '').trim());
  if (cleaned === '' || cleaned === '-' || cleaned === '.') return '0.00';
  return roundMoney(cleaned);
}

const MONEY_STRING = /^-?\d+\.\d{2}$/;

/** Always Western digits (0–9) — never Arabic-Indic numerals, even when UI is Arabic. */
export const DISPLAY_NUMBER_LOCALE = 'en-US';

/** Display money with thousands separators, e.g. 100000.00 → 100,000.00 */
export function formatMoneyDisplay(value: unknown): string {
  const normalized = roundMoney(value);
  const n = Number(normalized);
  if (!Number.isFinite(n)) return String(value ?? '');
  return new Intl.NumberFormat(DISPLAY_NUMBER_LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    numberingSystem: 'latn'
  }).format(n);
}

export function isMoneyString(value: string): boolean {
  return MONEY_STRING.test(value);
}
